"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var botframework_directlinejs_1 = require("botframework-directlinejs");
var Chat_1 = require("./Chat");
var Strings_1 = require("./Strings");
var SpeechModule_1 = require("./SpeechModule");
exports.shell = function (state, action) {
    if (state === void 0) { state = {
        input: '',
        sendTyping: false,
        listening: false,
        lastInputViaSpeech: false
    }; }
    switch (action.type) {
        case 'Update_Input':
            return tslib_1.__assign({}, state, { input: action.input, lastInputViaSpeech: action.source == "speech" });
        case 'Listening_Start':
            return tslib_1.__assign({}, state, { listening: true });
        case 'Listening_Stop':
            return tslib_1.__assign({}, state, { listening: false });
        case 'Send_Message':
            return tslib_1.__assign({}, state, { input: '' });
        case 'Set_Send_Typing':
            return tslib_1.__assign({}, state, { sendTyping: action.sendTyping });
        case 'Card_Action_Clicked':
            return tslib_1.__assign({}, state, { lastInputViaSpeech: false });
        default:
        case 'Listening_Starting':
            return state;
    }
};
exports.format = function (state, action) {
    if (state === void 0) { state = {
        locale: 'en-us',
        options: {
            showHeader: true
        },
        strings: Strings_1.defaultStrings,
        carouselMargin: undefined
    }; }
    switch (action.type) {
        case 'Set_Format_Options':
            return tslib_1.__assign({}, state, { options: tslib_1.__assign({}, state.options, action.options) });
        case 'Set_Locale':
            return tslib_1.__assign({}, state, { locale: action.locale, strings: Strings_1.strings(action.locale) });
        case 'Set_Measurements':
            return tslib_1.__assign({}, state, { carouselMargin: action.carouselMargin });
        default:
            return state;
    }
};
exports.size = function (state, action) {
    if (state === void 0) { state = {
        width: undefined,
        height: undefined
    }; }
    switch (action.type) {
        case 'Set_Size':
            return tslib_1.__assign({}, state, { width: action.width, height: action.height });
        default:
            return state;
    }
};
exports.connection = function (state, action) {
    if (state === void 0) { state = {
        connectionStatus: botframework_directlinejs_1.ConnectionStatus.Uninitialized,
        botConnection: undefined,
        selectedActivity: undefined,
        user: undefined,
        bot: undefined
    }; }
    switch (action.type) {
        case 'Start_Connection':
            return tslib_1.__assign({}, state, { botConnection: action.botConnection, user: action.user, bot: action.bot, selectedActivity: action.selectedActivity });
        case 'Connection_Change':
            return tslib_1.__assign({}, state, { connectionStatus: action.connectionStatus });
        default:
            return state;
    }
};
var copyArrayWithUpdatedItem = function (array, i, item) { return array.slice(0, i).concat([
    item
], array.slice(i + 1)); };
exports.history = function (state, action) {
    if (state === void 0) { state = {
        activities: [],
        clientActivityBase: Date.now().toString() + Math.random().toString().substr(1) + '.',
        clientActivityCounter: 0,
        selectedActivity: null
    }; }
    Chat_1.konsole.log("history action", action);
    switch (action.type) {
        case 'Set_History':
            return tslib_1.__assign({}, state, { activities: action.activities.slice() });
        // BLIS addition
        case 'Replace_Activity_Text':
            if (action.index >= state.activities.length) {
                return tslib_1.__assign({}, state);
            }
            if (state.activities[action.index].type !== 'message') {
                return tslib_1.__assign({}, state);
            }
            var activities = state.activities.slice();
            // Create new message with replaced text
            var message = tslib_1.__assign({}, activities[action.index]);
            message.text = action.text;
            message.textFormat = "markdown";
            // Swap for existing one
            activities[action.index] = message;
            return tslib_1.__assign({}, state, { activities: activities });
        case 'Receive_Sent_Message': {
            if (!action.activity.channelData || !action.activity.channelData.clientActivityId) {
                // only postBack messages don't have clientActivityId, and these shouldn't be added to the history
                return state;
            }
            var i_1 = state.activities.findIndex(function (activity) {
                return activity.channelData && activity.channelData.clientActivityId === action.activity.channelData.clientActivityId;
            });
            if (i_1 !== -1) {
                var activity_1 = state.activities[i_1];
                return tslib_1.__assign({}, state, { activities: copyArrayWithUpdatedItem(state.activities, i_1, activity_1), selectedActivity: state.selectedActivity === activity_1 ? action.activity : state.selectedActivity });
            }
            // else fall through and treat this as a new message
        }
        case 'Receive_Message':
            if (state.activities.find(function (a) { return a.id === action.activity.id; }))
                return state; // don't allow duplicate messages
            return tslib_1.__assign({}, state, { activities: state.activities.filter(function (activity) { return activity.type !== "typing"; }).concat([
                    action.activity
                ], state.activities.filter(function (activity) { return activity.from.id !== action.activity.from.id && activity.type === "typing"; })) });
        case 'Send_Message':
            return tslib_1.__assign({}, state, { activities: state.activities.filter(function (activity) { return activity.type !== "typing"; }).concat([
                    tslib_1.__assign({}, action.activity, { timestamp: (new Date()).toISOString(), channelData: { clientActivityId: state.clientActivityBase + state.clientActivityCounter } })
                ], state.activities.filter(function (activity) { return activity.type === "typing"; })), clientActivityCounter: state.clientActivityCounter + 1 });
        case 'Send_Message_Retry': {
            var activity_2 = state.activities.find(function (activity) {
                return activity.channelData && activity.channelData.clientActivityId === action.clientActivityId;
            });
            var newActivity_1 = activity_2.id === undefined ? activity_2 : tslib_1.__assign({}, activity_2, { id: undefined });
            return tslib_1.__assign({}, state, { activities: state.activities.filter(function (activityT) { return activityT.type !== "typing" && activityT !== activity_2; }).concat([
                    newActivity_1
                ], state.activities.filter(function (activity) { return activity.type === "typing"; })), selectedActivity: state.selectedActivity === activity_2 ? newActivity_1 : state.selectedActivity });
        }
        case 'Send_Message_Succeed':
        case 'Send_Message_Fail': {
            var i_2 = state.activities.findIndex(function (activity) {
                return activity.channelData && activity.channelData.clientActivityId === action.clientActivityId;
            });
            if (i_2 === -1)
                return state;
            var activity_3 = state.activities[i_2];
            if (activity_3.id && activity_3.id != "retry")
                return state;
            var newActivity_2 = tslib_1.__assign({}, activity_3, { id: action.type === 'Send_Message_Succeed' ? action.id : null });
            return tslib_1.__assign({}, state, { activities: copyArrayWithUpdatedItem(state.activities, i_2, newActivity_2), clientActivityCounter: state.clientActivityCounter + 1, selectedActivity: state.selectedActivity === activity_3 ? newActivity_2 : state.selectedActivity });
        }
        case 'Show_Typing':
            return tslib_1.__assign({}, state, { activities: state.activities.filter(function (activity) { return activity.type !== "typing"; }).concat(state.activities.filter(function (activity) { return activity.from.id !== action.activity.from.id && activity.type === "typing"; }), [
                    action.activity
                ]) });
        case 'Clear_Typing':
            return tslib_1.__assign({}, state, { activities: state.activities.filter(function (activity) { return activity.id !== action.id; }), selectedActivity: state.selectedActivity && state.selectedActivity.id === action.id ? null : state.selectedActivity });
        case 'Select_Activity':
            if (action.selectedActivity === state.selectedActivity)
                return state;
            return tslib_1.__assign({}, state, { selectedActivity: action.selectedActivity });
        case 'Deselect_Activity':
            return tslib_1.__assign({}, state, { selectedActivity: null });
        case 'Take_SuggestedAction':
            var i = state.activities.findIndex(function (activity) { return activity === action.message; });
            var activity = state.activities[i];
            var newActivity = tslib_1.__assign({}, activity, { suggestedActions: undefined });
            return tslib_1.__assign({}, state, { activities: copyArrayWithUpdatedItem(state.activities, i, newActivity), selectedActivity: state.selectedActivity === activity ? newActivity : state.selectedActivity });
        default:
            return state;
    }
};
var nullAction = { type: null };
var speakFromMsg = function (msg, fallbackLocale) {
    var speak = msg.speak;
    if (!speak && msg.textFormat == null || msg.textFormat == "plain")
        speak = msg.text;
    if (!speak && msg.channelData && msg.channelData.speechOutput && msg.channelData.speechOutput.speakText)
        speak = msg.channelData.speechOutput.speakText;
    if (!speak && msg.attachments && msg.attachments.length > 0)
        for (var i = 0; i < msg.attachments.length; i++) {
            var anymsg = msg;
            if (anymsg.attachments[i]["content"] && anymsg.attachments[i]["content"]["speak"]) {
                speak = anymsg.attachments[i]["content"]["speak"];
                break;
            }
        }
    return {
        type: 'Speak_SSML',
        ssml: speak,
        locale: msg.locale || fallbackLocale,
        autoListenAfterSpeak: (msg.inputHint == "expectingInput") || (msg.channelData && msg.channelData.botState == "WaitingForAnswerToQuestion"),
    };
};
// Epics - chain actions together with async operations
var redux_1 = require("redux");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/delay");
require("rxjs/add/operator/do");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/map");
require("rxjs/add/operator/merge");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/throttleTime");
require("rxjs/add/operator/takeUntil");
require("rxjs/add/observable/bindCallback");
require("rxjs/add/observable/empty");
require("rxjs/add/observable/of");
var sendMessage = function (action$, store) {
    return action$.ofType('Send_Message')
        .map(function (action) {
        var state = store.getState();
        var clientActivityId = state.history.clientActivityBase + (state.history.clientActivityCounter - 1);
        return { type: 'Send_Message_Try', clientActivityId: clientActivityId };
    });
};
var trySendMessage = function (action$, store) {
    return action$.ofType('Send_Message_Try')
        .flatMap(function (action) {
        var state = store.getState();
        var clientActivityId = action.clientActivityId;
        var activity = state.history.activities.find(function (activity) { return activity.channelData && activity.channelData.clientActivityId === clientActivityId; });
        if (!activity) {
            Chat_1.konsole.log("trySendMessage: activity not found");
            return Observable_1.Observable.empty();
        }
        if (state.history.clientActivityCounter == 1) {
            var capabilities = {
                type: 'ClientCapabilities',
                requiresBotState: true,
                supportsTts: true,
                supportsListening: true,
            };
            activity.entities = activity.entities == null ? [capabilities] : activity.entities.concat([capabilities]);
        }
        var result = state.connection.botConnection.postActivity(activity);
        // BLIS UI may eat action (i.e. disabled DL), in which case there is no result
        if (!result) {
            return Observable_1.Observable.empty();
        }
        else {
            return result.map(function (id) { return ({ type: 'Send_Message_Succeed', clientActivityId: clientActivityId, id: id }); })
                .catch(function (error) { return Observable_1.Observable.of({ type: 'Send_Message_Fail', clientActivityId: clientActivityId }); });
        }
    });
};
///const speakObservable = Observable.bindCallback<string, string, {}, {}>(Speech.SpeechSynthesizer.speak:any);
/*const speakSSML:Epic<ChatActions, ChatState> = (action$ : any, store) =>
    action$.ofType('Speak_SSML')
    .filter(action => action.ssml )
    .mergeMap(action => {

        var onSpeakingStarted =  null;
        var onSpeakingFinished = () => nullAction;
        if(action.autoListenAfterSpeak) {
            onSpeakingStarted = () => Speech.SpeechRecognizer.warmup() ;
            onSpeakingFinished = () => ({ type: 'Listening_Starting' } as ShellAction);
        }

        const call$ = speakObservable(action.ssml, action.locale, onSpeakingStarted);
        return call$.map(onSpeakingFinished)
            .catch(error => Observable.of(nullAction));
    })
    .merge(action$.ofType('Speak_SSML').map(_ => ({ type: 'Listening_Stop' } as ShellAction)));*/
var speakOnMessageReceived = function (action$, store) {
    return action$.ofType('Receive_Message')
        .filter(function (action) { return action.activity && store.getState().shell.lastInputViaSpeech; })
        .map(function (action) { return speakFromMsg(action.activity, store.getState().format.locale); });
};
var stopSpeaking = function (action$) {
    return action$.ofType('Update_Input', 'Listening_Starting', 'Send_Message', 'Card_Action_Clicked', 'Stop_Speaking')
        .do(SpeechModule_1.Speech.SpeechSynthesizer.stopSpeaking)
        .map(function (_) { return nullAction; });
};
var stopListening = function (action$) {
    return action$.ofType('Listening_Stop', 'Card_Action_Clicked')
        .do(SpeechModule_1.Speech.SpeechRecognizer.stopRecognizing)
        .map(function (_) { return nullAction; });
};
var startListening = function (action$, store) {
    return action$.ofType('Listening_Starting')
        .do(function (action) {
        var locale = store.getState().format.locale;
        var onIntermediateResult = function (srText) { store.dispatch({ type: 'Update_Input', input: srText, source: "speech" }); };
        var onFinalResult = function (srText) {
            srText = srText.replace(/^[.\s]+|[.\s]+$/g, "");
            onIntermediateResult(srText);
            store.dispatch({ type: 'Listening_Stop' });
            store.dispatch(Chat_1.sendMessage(srText, store.getState().connection.user, locale));
        };
        var onAudioStreamStart = function () { store.dispatch({ type: 'Listening_Start' }); };
        var onRecognitionFailed = function () { store.dispatch({ type: 'Listening_Stop' }); };
        SpeechModule_1.Speech.SpeechRecognizer.startRecognizing(locale, onIntermediateResult, onFinalResult, onAudioStreamStart, onRecognitionFailed);
    })
        .map(function (_) { return nullAction; });
};
var listeningSilenceTimeout = function (action$, store) {
    var cancelMessages$ = action$.ofType('Update_Input', 'Listening_Stop');
    return action$.ofType('Listening_Start')
        .mergeMap(function (action) {
        return Observable_1.Observable.of(({ type: 'Listening_Stop' }))
            .delay(5000)
            .takeUntil(cancelMessages$);
    });
};
var retrySendMessage = function (action$) {
    return action$.ofType('Send_Message_Retry')
        .map(function (action) { return ({ type: 'Send_Message_Try', clientActivityId: action.clientActivityId }); });
};
var updateSelectedActivity = function (action$, store) {
    return action$.ofType('Send_Message_Succeed', 'Send_Message_Fail', 'Show_Typing', 'Clear_Typing')
        .map(function (action) {
        var state = store.getState();
        if (state.connection.selectedActivity)
            state.connection.selectedActivity.next({ activity: state.history.selectedActivity });
        return nullAction;
    });
};
var showTyping = function (action$) {
    return action$.ofType('Show_Typing')
        .delay(3000)
        .map(function (action) { return ({ type: 'Clear_Typing', id: action.activity.id }); });
};
var sendTyping = function (action$, store) {
    return action$.ofType('Update_Input')
        .map(function (_) { return store.getState(); })
        .filter(function (state) { return state.shell.sendTyping; })
        .throttleTime(3000)
        .do(function (_) { return Chat_1.konsole.log("sending typing"); })
        .flatMap(function (state) {
        return state.connection.botConnection.postActivity({
            type: 'typing',
            from: state.connection.user
        })
            .map(function (_) { return nullAction; })
            .catch(function (error) { return Observable_1.Observable.of(nullAction); });
    });
};
// Now we put it all together into a store with middleware
var redux_2 = require("redux");
var redux_observable_1 = require("redux-observable");
exports.createStore = function () {
    return redux_2.createStore(redux_2.combineReducers({
        shell: exports.shell,
        format: exports.format,
        size: exports.size,
        connection: exports.connection,
        history: exports.history
    }), redux_1.applyMiddleware(redux_observable_1.createEpicMiddleware(redux_observable_1.combineEpics(updateSelectedActivity, sendMessage, trySendMessage, retrySendMessage, showTyping, sendTyping, 
    //   speakSSML,
    speakOnMessageReceived, startListening, stopListening, stopSpeaking, listeningSilenceTimeout))));
};
//# sourceMappingURL=Store.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/webchat/built/Store.js
// module id = 1386
// module chunks = 0